import Index from 'src/pages/Orders/Index.vue'
import Create from 'src/pages/Orders/Create.vue'
import Edit from 'src/pages/Orders/Edit.vue'
import Show from 'src/pages/Orders/Show.vue'

const auth = { requiresAuth: true }
const saveFrom = { saveFrom: true }

export default [
  {
    path: '/orders',
    name: 'Bestellungen',
    component: Index,
    meta: auth
  },
  {
    path: '/orders/create',
    name: 'Neue Bestellung anlegen',
    component: Create,
    meta: auth
  },
  {
    path: '/orders/:id',
    name: 'Bestellung',
    component: Show,
    meta: auth
  },
  {
    path: '/orders/:id/edit',
    name: 'Bestellung Bearbeiten',
    component: Edit,
    meta: { ...auth, ...saveFrom }
  }
]
